import {
    ADJUSTMENT_ADJUSTMENT_DISTRIBUTION_STATE_KEY,
    ADJUSTMENT_CATEGORY_STATE_KEY,
    ADJUSTMENT_SOURCE_DISTRIBUTION_STATE_KEY,
    ADJUSTMENT_STATUS_STATE_KEY,
    ARTIST_FIRST_NAME_STATE_KEY,
    ARTIST_LAST_NAME_STATE_KEY,
    CLAIM_CODE_STATE_KEY,
    CLAIM_DEPARTMENT_KEY,
    CLAIM_STATUS_STATE_KEY,
    CLAIM_TARGET_DISTRIBUTION_KEY,
    CLAIM_TYPE_STATE_KEY,
    CONTRIBUTORS_KEY,
    DISTRIBUTION_ENDDATE_KEY,
    DISTRIBUTION_POOLS_KEY,
    DISTRIBUTION_SETTINGS_KEY,
    DISTRIBUTION_STARTDATE_KEY,
    MEMBER_NUMBER_STATE_KEY,
    ORIGIN_STATE_KEY,
    PAYMENTRUN_CODE_STATE_KEY,
    PAYMENTRUN_PAYMENTRUN_DATE_STATE_KEY,
    POOL_ALLOCATION_RULE_STATE_KEY,
    POOL_DISTRIBUTION_CATEGORY_TYPE_STATE_KEY,
    POOL_POOL_CODE_STATE_KEY,
    PRODUCT_NAMES_KEY,
    PRODUCT_SOURCE_STATE_KEY,
    PRODUCT_TYPE_STATE_KEY,
    RIGHTHOLDER_ID_STATE_KEY,
    RIGHTHOLDER_NAME_STATE_KEY,
    SOURCE_IP_STATE_KEY,
    SOURCE_SOCIETY_STATE_KEY,
    SOURCE_STATE_KEY,
    SOURCE_TYPE_STATE_KEY,
    STATUS_STATE_KEY,
    TITLES_KEY,
    TYPES_OF_CALCULATION,
} from "../Consts";

const WORK_GENERAL_MANDATORY = new Set<string>([
    SOURCE_STATE_KEY,
    SOURCE_TYPE_STATE_KEY,
    STATUS_STATE_KEY,
]);
const WORK_ACCORDION_MANDATORY = new Set<string>([TITLES_KEY, CONTRIBUTORS_KEY]);
const PRODUCT_GENERAL_MANDATORY = new Set<string>([PRODUCT_TYPE_STATE_KEY, PRODUCT_SOURCE_STATE_KEY]);
const PRODUCT_ACCORDION_MANDATORY = new Set<string>([PRODUCT_NAMES_KEY]);
const POOL_GENERAL_MANDATORY = new Set<string>([
    POOL_POOL_CODE_STATE_KEY,
    POOL_ALLOCATION_RULE_STATE_KEY,
    POOL_DISTRIBUTION_CATEGORY_TYPE_STATE_KEY,
]);
const DISTRIBUTION_SECTION_MANDATORY = new Set<string>([DISTRIBUTION_POOLS_KEY, DISTRIBUTION_SETTINGS_KEY]);
const ADJUSTMENT_GENERAL_MANDATORY = new Set<string>([
    ADJUSTMENT_SOURCE_DISTRIBUTION_STATE_KEY,
    ADJUSTMENT_ADJUSTMENT_DISTRIBUTION_STATE_KEY,
    ADJUSTMENT_CATEGORY_STATE_KEY,
    ADJUSTMENT_STATUS_STATE_KEY,
]);
const ARTIST_GENERAL_MANDATORY = new Set<string>([ARTIST_FIRST_NAME_STATE_KEY, ARTIST_LAST_NAME_STATE_KEY]);
const PAYMENT_RUN_GENERAL_MANDATORY = new Set<string>([
    PAYMENTRUN_CODE_STATE_KEY,
    PAYMENTRUN_PAYMENTRUN_DATE_STATE_KEY,
]);
const CLAIM_GENERAL_MANDATORY = new Set<string>([
    MEMBER_NUMBER_STATE_KEY,
    RIGHTHOLDER_ID_STATE_KEY,
    RIGHTHOLDER_NAME_STATE_KEY,
    CLAIM_CODE_STATE_KEY,
    CLAIM_STATUS_STATE_KEY,
    CLAIM_TYPE_STATE_KEY,
    ORIGIN_STATE_KEY,
    CLAIM_DEPARTMENT_KEY,
    CLAIM_TARGET_DISTRIBUTION_KEY,
    DISTRIBUTION_STARTDATE_KEY,
    DISTRIBUTION_ENDDATE_KEY,
]);
const CLAIM_SECTION_MANDATORY = new Set<string>([TYPES_OF_CALCULATION]);

export function isWorkGeneralFieldMandatory(fieldName: string, sourceType?: string): boolean {
    if (WORK_GENERAL_MANDATORY.has(fieldName)) {
        return true;
    }
    if (fieldName === SOURCE_SOCIETY_STATE_KEY && sourceType === "SO") {
        return true;
    }
    if (fieldName === SOURCE_IP_STATE_KEY && (sourceType === "WR" || sourceType === "PB")) {
        return true;
    }
    return false;
}

export function isWorkAccordionFieldMandatory(fieldName: string): boolean {
    return WORK_ACCORDION_MANDATORY.has(fieldName);
}

export function isProductGeneralFieldMandatory(fieldName: string): boolean {
    return PRODUCT_GENERAL_MANDATORY.has(fieldName);
}

export function isProductAccordionFieldMandatory(fieldName: string): boolean {
    return PRODUCT_ACCORDION_MANDATORY.has(fieldName);
}

export function isPoolGeneralFieldMandatory(fieldName: string): boolean {
    return POOL_GENERAL_MANDATORY.has(fieldName);
}

export function isDistributionSectionMandatory(sectionName: string): boolean {
    return DISTRIBUTION_SECTION_MANDATORY.has(sectionName);
}

export function isAdjustmentGeneralFieldMandatory(fieldName: string): boolean {
    return ADJUSTMENT_GENERAL_MANDATORY.has(fieldName);
}

export function isArtistGeneralFieldMandatory(fieldName: string): boolean {
    return ARTIST_GENERAL_MANDATORY.has(fieldName);
}

export function isPaymentRunGeneralFieldMandatory(fieldName: string): boolean {
    return PAYMENT_RUN_GENERAL_MANDATORY.has(fieldName);
}

export function isClaimGeneralFieldMandatory(fieldName: string): boolean {
    return CLAIM_GENERAL_MANDATORY.has(fieldName);
}

export function isClaimSectionMandatory(sectionName: string): boolean {
    return CLAIM_SECTION_MANDATORY.has(sectionName);
}
